import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IPrepaidDataFormMeta {
    newCardDesign: FormInputMeta;
    anonymousCard: FormInputMeta;
    third: FormInputMeta;

}

const prepaidDataFormMeta = {} as IPrepaidDataFormMeta;

prepaidDataFormMeta.newCardDesign = {
    name: "newCardDesign",
    type: "checkbox",
    label: "Concep. Nouv. Carte",
    placeholder: "",
    validation: yup.boolean(),
};

prepaidDataFormMeta.anonymousCard = {
    name: "anonymousCard",
    type: "checkbox",
    label: "Carte Anonyme",
    placeholder: "",
    validation: yup.boolean(),
};

export default prepaidDataFormMeta;